import { Box } from '@mui/material'

const BroadCastPage = () => {
  return (
    <Box
      id="fb-content"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'stretch',
        marginTop: '-20px',
      }}
    ></Box>
  )
}

export default BroadCastPage
